import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Dialog } from 'primereact/dialog';
import TabView from '@gym-atoms/TabView/TabView';
import { Member } from '@gym-particles/types/Member';
import MemberDetailsGeneral from './MemberDetailsGeneral';
import MemberDetailsActivity from './MemberDetailsActivity';
import MemberDetailsAccessMethods from './MemberDetailsAccessMethods';

export const MemberDetailsModalContent = (props: {
  member: Member;
  setForceResync: MemberDetailsModalProps['setForceResync'];
  gymId?: number;
  chainId?: number;
  stayOnCurrentPage?: boolean;
}) => {
  const { t } = useTranslation();
  const routeParams = useParams<{ gymId: string; chainId: string }>();
  const gymId = props.gymId ?? Number(routeParams.gymId);
  const chainId = props.chainId ?? Number(routeParams.chainId);

  const tabViewItems = [
    {
      header: t('MEMBER_DETAILS_MODAL.TAB_HEADER_GENERAL'),
      content: (
        <MemberDetailsGeneral
          member={props.member}
          setForceResync={props.setForceResync}
          gymId={gymId}
          chainId={chainId}
          stayOnCurrentPage={props.stayOnCurrentPage}
        />
      )
    },
    {
      header: t('MEMBER_DETAILS_MODAL.TAB_HEADER_ACCESS_LOG'),
      content: <MemberDetailsActivity gymId={gymId} memberId={props.member.id} />
    }
  ];

  const conditionalTabItems = [
    {
      header: t('MEMBER_DETAILS_MODAL.TAB_HEADER_ACCESS_METHODS'),
      content: <MemberDetailsAccessMethods member={props.member} gymId={gymId} />
    }
  ];

  return <TabView items={[...tabViewItems, ...conditionalTabItems]} />;
};

const MemberDetailsModal = (props: MemberDetailsModalProps) => {
  return (
    <Dialog
      className={'detailed-modal'}
      modal
      draggable={false}
      dismissableMask
      visible={props.visible}
      onHide={props.modalOnHide}
      position={'top'}
      style={{ width: '75vw' }}
      header={
        <MemberDetailsModalContent
          member={props.member}
          setForceResync={props.setForceResync}
          gymId={props.gymId}
          chainId={props.chainId}
          stayOnCurrentPage={props.stayOnCurrentPage}
        />
      }></Dialog>
  );
};

export interface MemberDetailsModalProps {
  /** Controls the visibility of the modal */
  visible: boolean;
  /** Runs when modal is closed */
  modalOnHide: () => void;
  /** Member data to populate the modal */
  member: Member;
  setForceResync: (value: number) => void;
  gymId?: number;
  chainId?: number;
  stayOnCurrentPage?: boolean;
}

export default MemberDetailsModal;
